import { useEffect, useState } from 'react';

/**
 * Rota atual pela hash (`#/cobrancas`).
 *
 * Hash em vez de History API de propósito: o console é servido como estático
 * (nginx no build de produção) e não há servidor de app para reescrever rotas
 * — `#` mantém tudo numa página só sem 404 ao recarregar em `/cobrancas`.
 */
export function useHashRoute(padrao: string): [string, (id: string) => void] {
  const ler = () => window.location.hash.replace(/^#\/?/, '') || padrao;
  const [rota, setRota] = useState<string>(ler);

  useEffect(() => {
    const aoMudar = () => setRota(ler());
    window.addEventListener('hashchange', aoMudar);
    return () => window.removeEventListener('hashchange', aoMudar);
  }, []);

  const navegar = (id: string) => {
    window.location.hash = `/${id}`;
  };

  return [rota, navegar];
}
